import { useCallback, useRef } from 'react';

import { trackCtaClicked } from '@zola-helpers/client/dist/es/tracking/ctaEvents/ctaEvents';
import { CtaEventDataType } from '@zola-helpers/client/dist/types/tracking/ctaEvents/ctaEvents.d';

export const useCtaTracking = <T extends HTMLElement>(trackingPayload: CtaEventDataType) => {
  const inViewportRef = useRef<T>(null);

  const handleClick = useCallback(() => {
    trackCtaClicked(trackingPayload);
  }, [trackingPayload]);

  return {
    inViewportRef,
    handleClick,
  };
};
